import { css, cx, useTheme } from '@fable/theme'
import { useEffect, useState } from 'react'
import { useTypedSelector } from '../../../hooks'
import {
  FeaturedEventAuth,
  FeaturedEventMasthead,
} from '../components/featured_event'
import { useFeaturedEvent } from '../context'

export const postAuthRegisterEventKey = 'postAuthRegisterEventKey'

const FeaturedEvent: React.VFC = () => {
  const { event, registerUserToEvent, checkRegistrationStatus } =
    useFeaturedEvent()
  const { mediaQueries } = useTheme()
  const { isAuthenticated } = useTypedSelector(({ auth }) => auth)
  const [fetchedStatus, setFetchedStatus] = useState(false)

  useEffect(() => {
    if (!fetchedStatus && isAuthenticated) {
      checkRegistrationStatus()
      setFetchedStatus(true)
    }
  }, [checkRegistrationStatus, fetchedStatus, isAuthenticated])

  useEffect(() => {
    const postAuthKey = localStorage.getItem(postAuthRegisterEventKey)
    if (postAuthKey && isAuthenticated) {
      registerUserToEvent()
      localStorage.removeItem(postAuthRegisterEventKey)
    }
  }, [event, isAuthenticated, registerUserToEvent])

  return (
    <div
      data-testid="featuredEvent"
      className={cx(
        css`
          background-color: ${event.secondaryColor};
          min-height: 100vh;
          ${mediaQueries.mobileL} {
            padding: 48px;
          }
        `,
        'fade'
      )}
    >
      <div
        className={css`
          margin: 0 auto;
          max-width: 600px;

          overflow: hidden;
          ${mediaQueries.mobileL} {
            border-radius: 20px;
            border-top-right-radius: 90px;
          }
        `}
      >
        <FeaturedEventMasthead />
        {isAuthenticated ? null : <FeaturedEventAuth />}
      </div>
    </div>
  )
}

export default FeaturedEvent
